import React from 'react';
import ReactDOM from 'react-dom/client';
import {
  createBrowserRouter,
  createHashRouter,
  RouterProvider,
  Route,
  useLocation
} from "react-router-dom";
import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";
import './index.css';
import App from './App';

import Productos from './Productos';
import Digital from './Digital';
import Sostenibilidad from './Sostenibilidad';
import Especiales from './Especiales';

import Productos_Resumen from './Productos_Resumen';
import Vivienda from './Vivienda';
import Arquitectonicos from './Arquitectonicos';
import Pisos from './Pisos';

import JuegaFullColor from './JuegaFullColor';
import MetodosModernos from './MetodosModernos';
import ConoceMiObra from './ConoceMiObra';

import Fullcolor from './Fullcolor';
import Termomuro from './Termomuro';
import Wallmix from './Wallmix';
import Coopermix from './Coopermix';
import Viamix from './Viamix';
import Pisomix from './Pisomix';
import Melon3d from './Melon3d';
import Drencret from './Drencret';
import TerminacionHelicoptero from './TerminacionHelicoptero';
import Powermix from './Powermix';
import HormigonFibra from './HormigonFibra';
import Shotcrete from './Shotcrete';
import Continua from './Continua';
import Durenza from './Durenza';
import HormigonPoroso from './HormigonPoroso';
import FastTrack from './FastTrack';
import Freezermix from './Freezermix';
import DesmoldeTemprano from './DesmoldeTemprano';
import Dt14 from './dt14';
import Fluidia from './Fluidia';
import Fluimix from './Fluimix';
import Fluido from './Fluido';
import Hormigon13 from './Hormigon13';
import HormigonPerlado from './HormigonPerlado';
import ResistenciaTemprana from './ResistenciaTemprana';
import HRC from './HRC';
import Losamix from './Losamix';
import Pegamix from './Pegamix';
import RDC from './RDC';
import HormigonTiempoViaje from './HormigonTiempoViaje';
import HormigonTiempoEspera from './HormigonTiempoEspera';
import HormigonSeco from './HormigonSeco';
import Infomix from './Infomix';
import ArtepolisVisto from './ArtepolisVisto';
import ArtepolisCantoRodado from './ArtepolisCantoRodado';

import Productos_Losamixhac from './Productos_Losamixhac';
import Productos_Duramax from './Productos_Duramax';

import SelloDigital from './SelloDigital';
import MiPlanta from './MiPlanta';
import AccesoObra from './AccesoObra';
import Alquimia from './Alquimia';
import MiFlota from './MiFlota';
import MiMixer from './MiMixer';
import ProgramacionOnline from './ProgramacionOnline';
import MiSeguridad from './MiSeguridad';
import Optimix from './Optimix';
import MiObra from './MiObra';
import ConoEnLinea from './ConoEnLinea';

import Sostenibilidad_Nuestro from './Sostenibilidad_Nuestro';
import Sostenibilidad_Politica from './Sostenibilidad_Politica';
import Sostenibilidad_Estrategia from './Sostenibilidad_Estrategia';
import Sostenibilidad_Liderazgo from './Sostenibilidad_Liderazgo';
import Sostenibilidad_Cadena from './Sostenibilidad_Cadena';
import Sostenibilidad_Compromiso from './Sostenibilidad_Compromiso';

import PE_ObrasCiviles from './PE_ObrasCiviles';
import PE_Mineras from './PE_Mineras';
import PE_Energias from './PE_Energias';
import PE_Moviles from './PE_Moviles';

import PE_Coyahuasi from './PE_Coyahuasi';
import PE_CaboLeones from './PE_CaboLeones';
import PE_Solar from './PE_Solar';
import PE_Metro from './PE_Metro';
import PE_Quebrada from './PE_Quebrada';
import PE_Teniente from './PE_Teniente';
import PE_Pelambres from './PE_Pelambres';


import Decomix from './Decomix';
import Lowmix from './Lowmix';
import Mix3d from './Mix3d';

import Sostenibilidad_Cuidado from './Sostenibilidad_Cuidado';
import Sostenibilidad_Carbono from './Sostenibilidad_Carbono';
import Sostenibilidad_Economia from './Sostenibilidad_Economia';
import Sostenibilidad_Energia from './Sostenibilidad_Energia';
import Sostenibilidad_Eficiencia from './Sostenibilidad_Eficiencia';
import Sostenibilidad_Biodiversidad from './Sostenibilidad_Biodiversidad';
import Sostenibilidad_Proveedores from './Sostenibilidad_Proveedores';
import Sostenibilidad_Personas from './Sostenibilidad_Personas';
import Sostenibilidad_Reconocimientos from './Sostenibilidad_Reconocimientos';

import CalculaHuellaCarbono from './CalculaHuellaCarbono';


import reportWebVitals from './reportWebVitals';

const router = createHashRouter([
  {
    path: "/",
    element: <App />,
  },  
  {
    path: "/productos",
    element: <Productos />,
  },
  {
    path: "/digital",
    element: <Digital />,
  },
  {
    path: "/sostenibilidad",
    element: <Sostenibilidad />,
  },
  {
    path: "/especiales",
    element: <Especiales />,
  },   
  {
    path: "/digital/sellodigital",
    element: <SelloDigital />,
  },
  {
    path: "/digital/miplanta",
    element: <MiPlanta />,
  },
  {
    path: "/digital/accesoobra",
    element: <AccesoObra />,
  },
  {
    path: "/digital/alquimia",
    element: <Alquimia />,
  },
  {
    path: "/digital/miflota",
    element: <MiFlota />,
  },
  {
    path: "/digital/mimixer",
    element: <MiMixer />,
  },
  {
    path: "/digital/programaciononline",
    element: <ProgramacionOnline />,
  },
  {
    path: "/digital/miseguridad",
    element: <MiSeguridad />,
  },
  {
    path: "/digital/infomix",
    element: <Infomix />,
  },
  {
    path: "/digital/optimix",
    element: <Optimix />,
  },
  {
    path: "/digital/miobra",
    element: <MiObra />,
  },
  {
    path: "/digital/conoenlinea",
    element: <ConoEnLinea />,
  },            
  {
    path: "/productos/vivienda",
    element: <Vivienda />,
  },
  {
    path: "/productos/vivienda/wallmix",
    element: <Wallmix />,
  },
  {
    path: "/productos/vivienda/freezermix",
    element: <Freezermix />,
  },
  {
    path: "/productos/vivienda/desmoldetemprano",
    element: <DesmoldeTemprano />,
  },
  {
    path: "/productos/vivienda/dt14",
    element: <Dt14 />,
  },  
  {
    path: "/productos/vivienda/fluidia",
    element: <Fluidia />,
  },
  {
    path: "/productos/vivienda/fluimix",
    element: <Fluimix />,
  },
  {
    path: "/productos/vivienda/fluido",
    element: <Fluido />,
  },
  {
    path: "/productos/vivienda/hormigon13",
    element: <Hormigon13 />,
  },
  {
    path: "/productos/vivienda/hormigonperlado",
    element: <HormigonPerlado />,
  },  
  {
    path: "/productos/vivienda/resistenciatemprana",
    element: <ResistenciaTemprana />,
  },
  {
    path: "/productos/vivienda/hrc",
    element: <HRC />,
  },
  {
    path: "/productos/vivienda/losamix",
    element: <Losamix />,
  },
  {
    path: "/productos/vivienda/pegamix",
    element: <Pegamix />,
  },
  {
    path: "/productos/vivienda/rdc",
    element: <RDC />,
  },
  {
    path: "/productos/vivienda/hormigontiempoviaje",
    element: <HormigonTiempoViaje />,
  },
  {
    path: "/productos/vivienda/hormigontiempoespera",
    element: <HormigonTiempoEspera />,
  },
  {
    path: "/productos/vivienda/hormigonseco",
    element: <HormigonSeco />,
  },
  {
    path: "/productos/vivienda/infomix",
    element: <Infomix />,
  },    
  {
    path: "/productos/arquitectonicos",
    element: <Arquitectonicos />,
  },
  {
    path: "/productos/arquitectonicos/fullcolor",
    element: <Fullcolor />,
  },
  {
    path: "/productos/arquitectonicos/termomuro",
    element: <Termomuro />,
  },
  {
    path: "/productos/arquitectonicos/artepolisvisto",
    element: <ArtepolisVisto />,
  },
  {
    path: "/productos/arquitectonicos/artepoliscantorodado",
    element: <ArtepolisCantoRodado />,
  },
  {
    path: "/productos/arquitectonicos/decomix",
    element: <Decomix />,
  },
  {
    path: "/productos/arquitectonicos/lowmix",
    element: <Lowmix />,
  },
  {
    path: "/productos/arquitectonicos/mix3d",
    element: <Mix3d />,
  },  
  {
    path: "/productos/pisos",
    element: <Pisos />,
  },
  {
    path: "/productos/pisos/coopermix",
    element: <Coopermix />,
  },
  {
    path: "/productos/pisos/viamix",
    element: <Viamix />,
  },
  {
    path: "/productos/pisos/pisomix",
    element: <Pisomix />,
  },
  {
    path: "/productos/pisos/melon3d",
    element: <Melon3d />,
  },
  {
    path: "/productos/pisos/drencret",
    element: <Drencret />,
  },
  {
    path: "/productos/pisos/terminacionhelicoptero",
    element: <TerminacionHelicoptero />,
  },
  {
    path: "/productos/pisos/powermix",
    element: <Powermix />,
  },
  {
    path: "/productos/pisos/hormigonfibra",
    element: <HormigonFibra />,
  },
  {
    path: "/productos/pisos/shotcrete",
    element: <Shotcrete />,
  },
  {
    path: "/productos/pisos/continua",
    element: <Continua />,
  },
  {
    path: "/productos/pisos/durenza",
    element: <Durenza />,
  },
  {
    path: "/productos/pisos/hormigonporoso",
    element: <HormigonPoroso />,
  },
  {
    path: "/productos/pisos/fasttrack",
    element: <FastTrack />,
  },    
  {
    path: "/juega",
    element: <JuegaFullColor />,
  },
  {
    path: "/calcula",
    element: <CalculaHuellaCarbono />,
  },  
  {
    path: "/mmc",
    element: <MetodosModernos />,
  },  
  {
    path: "/conoce",
    element: <ConoceMiObra />,
  },
  {
    path: "/sostenibilidad/nuestro",
    element: <Sostenibilidad_Nuestro />,
  },
  {
    path: "/sostenibilidad/politica",
    element: <Sostenibilidad_Politica />,
  },
  {
    path: "/sostenibilidad/estrategia",
    element: <Sostenibilidad_Estrategia />,
  },
  {
    path: "/sostenibilidad/liderazgo",
    element: <Sostenibilidad_Liderazgo />,
  },
  {
    path: "/sostenibilidad/cadena",
    element: <Sostenibilidad_Cadena />,
  },
  {
    path: "/sostenibilidad/compromiso",
    element: <Sostenibilidad_Compromiso />,
  },
  {
    path: "/sostenibilidad/cuidado",
    element: <Sostenibilidad_Cuidado />,
  },
  {
    path: "/sostenibilidad/carbono",
    element: <Sostenibilidad_Carbono />,
  },
  {
    path: "/sostenibilidad/economia",
    element: <Sostenibilidad_Economia />,
  },
  {
    path: "/sostenibilidad/energia",
    element: <Sostenibilidad_Energia />,
  },
  {
    path: "/sostenibilidad/eficiencia",
    element: <Sostenibilidad_Eficiencia />,
  },
  {
    path: "/sostenibilidad/biodiversidad",
    element: <Sostenibilidad_Biodiversidad />,
  },
  {
    path: "/sostenibilidad/proveedores",
    element: <Sostenibilidad_Proveedores />,
  },
  {
    path: "/sostenibilidad/personas",
    element: <Sostenibilidad_Personas />,
  },
  {
    path: "/sostenibilidad/reconocimientos",
    element: <Sostenibilidad_Reconocimientos />,
  },    
  {
    path: "/productos/resumen",
    element: <Productos_Resumen />,
  },
  {
    path: "/productos/vivienda/losamixhac",
    element: <Productos_Losamixhac />,
  },
  {
    path: "/productos/vivienda/duramax",
    element: <Productos_Duramax />,
  },
  {
    path: "/especiales/obrasciviles",
    element: <PE_ObrasCiviles />,
  },
  {
    path: "/especiales/mineras",
    element: <PE_Mineras />,
  },
  {
    path: "/especiales/energias",
    element: <PE_Energias />,
  },
  {
    path: "/especiales/moviles",
    element: <PE_Moviles />,
  },
  {
    path: "/especiales/coyahuasi",
    element: <PE_Coyahuasi />,
  },
  {
    path: "/especiales/caboleones",
    element: <PE_CaboLeones />,
  },
  {
    path: "/especiales/solar",
    element: <PE_Solar />,
  },
  {
    path: "/especiales/metro",
    element: <PE_Metro />,
  },
  {
    path: "/especiales/quebrada",
    element: <PE_Quebrada />,
  },
  {
    path: "/especiales/teniente",
    element: <PE_Teniente />,
  },
  {
    path: "/especiales/pelambres",
    element: <PE_Pelambres />,
  },    
]);

const root = ReactDOM.createRoot(document.getElementById('react-root'));

root.render(
  <React.StrictMode>
        <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
